import { Directive, effect, input, signal } from '@angular/core'

import { fonts, theme } from '@flowx/core-sdk'
import { InputSelectionStyles, applyTextareaCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-textarea',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxTextareaStyleDirective {
  componentStyle = input<{
    style: InputSelectionStyles
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applyTextareaCustomStyles(
        this.componentStyle().style,
        theme(),
        fonts()
      )
      this.styleClassName.set(className)
    })
  }
}
